<div class="flex flex-row items-center justify-center gap-2" [class]="badgeClass">
  <mat-icon>{{icon}}</mat-icon>
  <div>{{text}}</div>
</div>
